import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import TechnologySection from './components/TechnologySection';
import CustomizationSection from './components/CustomizationSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SeoSection from './components/SeoSection';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />

      <main>


        {/* VISUAL HERO */}
        <HeroSection />

        <AboutSection />
        <ProductsSection />
        <TechnologySection />
        <CustomizationSection />
        <ServicesSection />
        <ContactSection />

        {/* SEO CONTENT (IMPORTANT) */}
        <SeoSection />
      </main>

      <Footer />
    </div>
  );
}


export default App;
